import HiddenCollapsibleText from './HiddenCollapsibleText'


export default HiddenCollapsibleText
